define('utils/body-scroll',[
    'jquery',
    'utils/bind-manager'
    ],
    function ($, bindMng) {
        var BodyScroll = (function () {
            
            var body = $('body'),
                html = $('html'),
                $window = $(window);

            /**
             * Used to prevent scrolling of body 
             * if it is touch device, wrap the whole page and hide it
             */
            function BodyScroll () {
                this.counter = 0;
            }

            BodyScroll.prototype.lock = function() {
                var _this = this;
                
                if (!this.counter) {
                    this.destroy = $.Deferred();
                    this.scrollTop = $window.scrollTop();
                    this.hideBodyOnTouchDevice();
                    this.hideScroll();

                    if ( !Modernizr.touch ) {
                        $window.on('scroll.lockScroll', function(e){
                            e.preventDefault();
                            $window.scrollTop(_this.scrollTop);
                        });

                        this.destroy.done(function() {
                            $window.off('scroll.lockScroll');
                        });
                    }
                }
                this.counter++;
            };

            BodyScroll.prototype.unlock = function() {
                if (--this.counter < 0) {
                    this.counter = 0;
                } else if (this.counter === 0) {
                    this.destroy.resolve();
                }
            };

            BodyScroll.prototype.hideBodyOnTouchDevice = function() {
                if ( Modernizr.touch ) {
                    var pageWrapper = $('.page-wrapper');

                    if (!pageWrapper.length) {
                        pageWrapper = $('<div class="page-wrapper"></div>');                        
                        body.wrapInner(pageWrapper);
                        // Rebind since the DOM changed
                        bindMng.rebind();
                    }
                }
            };

             BodyScroll.prototype.hideScroll = function() {
                html.addClass('overflow-hidden');

                var _this = this;

                this.destroy.done(function() {
                    html.removeClass('overflow-hidden');
                    $window.scrollTop(_this.scrollTop);
                });
            };

            return BodyScroll;
        })();

        return new BodyScroll();
    }
);
